// src/views/Settings/SectionLoader.jsx
//
// Espera dentro del shell, no encima. Un `<Loading/>` a pantalla completa hacía
// desaparecer la barra lateral y volver, y eso se lee como un salto, no como una
// carga.
import React from 'react';
import Spinner from '../../components/Spinner';

export default function SectionLoader({ label }) {
  return (
    <div className="flex flex-1 items-center justify-center py-16">
      <Spinner size="md" color="purple" label={label} />
    </div>
  );
}
